<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8.41129C0 3.76586 3.76587 0 8.41129 0H39.5887C44.2341 0 48 3.76587 48 8.41129V39.5887C48 44.2341 44.2341 48 39.5887 48H8.41129C3.76586 48 0 44.2341 0 39.5887V8.41129Z"
      fill="#F0F2FA"
    />
    <path
      opacity="0.3"
      d="M24 36C30.6274 36 36 30.6274 36 24C36 17.3726 30.6274 12 24 12C17.3726 12 12 17.3726 12 24C12 30.6274 17.3726 36 24 36Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.505 30.1896L28.1482 22.902C28.2167 22.7648 28.249 22.6124 28.2421 22.4592C28.2351 22.306 28.1891 22.1571 28.1084 22.0267C28.0278 21.8962 27.9151 21.7886 27.7811 21.7139C27.6472 21.6392 27.4964 21.6 27.343 21.6H23.9998V18.2124C23.9998 18.0097 23.9313 17.8128 23.8054 17.6538C23.6796 17.4949 23.5037 17.383 23.3063 17.3365C23.109 17.29 22.9017 17.3115 22.718 17.3975C22.5344 17.4835 22.3852 17.629 22.2946 17.8104L18.6514 25.098C18.5829 25.2353 18.5506 25.3877 18.5576 25.5409C18.5645 25.6941 18.6105 25.843 18.6912 25.9734C18.7719 26.1039 18.8845 26.2115 19.0185 26.2862C19.1524 26.3608 19.3032 26.4 19.4566 26.4H22.7998V29.7876C22.7998 29.9904 22.8683 30.1873 22.9942 30.3462C23.1201 30.5052 23.2959 30.617 23.4933 30.6636C23.6907 30.7101 23.898 30.6886 24.0816 30.6026C24.2652 30.5166 24.4144 30.3711 24.505 30.1896Z"
      fill="black"
    />
  </svg>
</template>
